import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OfferCard from './OfferCard';
import { moveSectionDown, moveSectionUp, removeSection, setSectionFormType, setSectionType } from '../../../../../../Features/storefrontSlice';
import { showToast } from '../../../../../../Components/Toaster/Toaster';
import EditPencil from '../../../../../../Assets/StorefrontIcons/EditPencil.svg';
import ArrowUp from '../../../../../../Assets/StorefrontIcons/ArrowUp.svg';
import Delete from '../../../../../../Assets/DeleteRed.svg';

function OfferDisplayDesktop({ item }) {
    const dispatch = useDispatch();
    const [buttonsVisible, setButtonsVisible] = useState(false);
    const [hoverOnBox, setHoverOnBox] = useState(false);

    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const mobileItem = versionStack[versionIndex]?.versionData.find(section => section.item.typeData === item.item.typeData);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setTextSize((zoomSize/100)*14);
        setLineHeight((zoomSize/100)*20);
    }, [zoomSize]);

    useEffect(() => {
        if(hoverOnBox) {
            setButtonsVisible(true);
        } else {
            setButtonsVisible(false);
        }
    }, [hoverOnBox]);

    function handleEditClick() {
        dispatch(setSectionType('SECTION'));
        dispatch(setSectionFormType('OFFER_DISPLAY_DESKTOP'));
    }

    function handleUpClick() {
        if(item.prev) {
            dispatch(moveSectionUp({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDownClick() {
        if(item.next) {
            dispatch(moveSectionDown({ item, mobileItem }));
        }
        else {
            showToast('Action failed!', 'warning');
        }
    }

    function handleDeleteClick() {
        dispatch(removeSection({ item, mobileItem }));
    }

    return (
        <div 
            onMouseEnter={() => setHoverOnBox(true)} 
            onMouseLeave={() => setHoverOnBox(false)} 
            className='w-full flex flex-col gap-2 relative' 
        >
            {
                buttonsVisible && 
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 flex items-center rounded-md overflow-hidden bg-[#FFFFFF]">
                    <button onClick={handleEditClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={EditPencil} alt="" />
                    </button>
                    <button onClick={handleUpClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDownClick} className='outline-none size-8 flex items-center justify-center'>
                        <img className='rotate-180' src={ArrowUp} alt="" />
                    </button>
                    <button onClick={handleDeleteClick} className='outline-none size-8 flex items-center justify-center'>
                        <img src={Delete} alt="" />
                    </button>
                </div>
            }

            <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='px-4 font-semibold text-[#000000]'>{item.item.name}</p>

            <div className="px-4 w-full flex flex-nowrap gap-3 overflow-x-scroll no-scrollbar">
                {item.item.offersList?.map(offer => {
                    return (
                        <OfferCard 
                            key={offer.id} 
                            offer={offer} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default OfferDisplayDesktop;
